import type { QueryProps } from "shared/react";
import type { MessageData } from "shared/schema";
import { List } from "shared/react";
import { useQuery } from "../util/db.js";
import { Message } from "./Message.js";

export function MessageList({ query, ...props }: QueryProps<MessageData>): React.ReactElement {
	return (
		<List //
			store={useQuery("message", query)}
			mapper={({ id }) => <Message key={id} id={id} />}
			{...props}
		/>
	);
}
